import React, { useState } from 'react';
import styles from '@/pages/Dashboard/Dashboard.module.scss';
import Textfield from '@/components/atomics/Textfield';
import Button from '@/components/atomics/Button';
import Icon from '@/components/atomics/Icons';

const className = 'dashboard';

type DashboardFilterProps = {
  onSearch: (params: { ndmain: string; email: string; uuid: string; sc_number: string }) => void;
};

const DashboardFilter: React.FC<DashboardFilterProps> = ({ onSearch }) => {
  const [ndmain, setNdmain] = useState('');
  const [email, setEmail] = useState('');
  const [uuid, setUuid] = useState('');
  const [scNumber, setScNumber] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch({ ndmain, email, uuid, sc_number: scNumber });
  };

  return (
    <form className={styles[className + '__card__form']} onSubmit={handleSubmit}>
      <Textfield
        iconLeft={<Icon name="Search" />}
        placeholder="Masukkan E-mail"
        className={styles[className + '__card__form__textfield']}
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <Textfield
        iconLeft={<Icon name="Search" />}
        placeholder="Masukkan Nomor Internet / Nomor Digital"
        className={styles[className + '__card__form__textfield']}
        value={ndmain}
        onChange={e => setNdmain(e.target.value)}
      />
      <Textfield
        iconLeft={<Icon name="Search" />}
        placeholder="Masukkan UUID"
        className={styles[className + '__card__form__textfield']}
        value={uuid}
        onChange={e => setUuid(e.target.value)}
      />
      <Textfield
        iconLeft={<Icon name="Search" />}
        placeholder="Masukkan SC Number"
        className={styles[className + '__card__form__textfield']}
        value={scNumber}
        onChange={e => setScNumber(e.target.value)}
      />
      <Button
        className={styles[className + '__card__form__button']}
        disabled={!email && !uuid && !scNumber && !ndmain}
        type="submit"
      >
        Cari
      </Button>
    </form>
  );
};

export default DashboardFilter;